import React, { Fragment, ReactNode } from 'react';

import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';
import { ImageMozaic } from './ImageMozaic';
import { VideoMosaic } from './VideoMosaic';
import { ButtonCardMosaic } from './ButtonCardMosaic';
import { ImageProps } from '../Image/types';

export interface MosaicItem extends DefaultBsComponent {
  type: 'image' | 'video' | 'buttonCard';
  image?: ImageProps;
  video?: ReactNode;
  onClickVideoThumbnail?: any;
  button?: ReactNode;
}

export interface MosaicProps {
  items: MosaicItem[];
}

const computeStylesFromIndex = (i: number) => {
  switch (i) {
    case 0:
      return 'xl:w-4/12 lg:w-4/12 md:w-1/2 lg:h-4/6 md:flex md:self-end justify-self-center md:pr-12 pb-12';
    case 1:
      return 'xl:w-5/12 lg:w-5/12 md:w-1/2 lg:h-[407px] lg:flex order-first md:order-none md:self-end justify-self-center md:pl-12 pb-12 lg:px-12';
    case 2:
      return 'xl:w-3/12 lg:w-3/12 hidden lg:flex lg:inline lg:h-4/6 md:self-end justify-self-center md:pl-12 pb-12';
    case 3:
      return 'xl:w-3/12 lg:w-3/12 md:w-1/2 lg:h-4/6 md:pr-12 pt-12';
    case 4:
      return 'xl:w-5/12 lg:w-4/12 hidden lg:flex lg:inline h-full lg:h-[407px] md:pl-12 pt-12 lg:px-12';
    case 5:
      return 'xl:w-3/12 lg:w-3/12 md:w-1/2 lg:h-4/6 md:pl-12 pt-12';
    default:
      return '';
  }
};
const computeSizesFromIndex = (i: number) => {
  const commonSizes = [
    '(max-width: 350px) 317px',
    '(max-width: 480px) 450px',
    '(max-width: 768px) 719px',
    '(max-width: 1024px) 360px',
  ];
  switch (i) {
    case 0:
      return [...commonSizes, '(max-width: 1280px) 325px', '388px'];
    case 1:
      return [
        ...commonSizes,
        '(max-width: 1280px) 400px',
        '(max-width: 1440px) 475px',
        '500px',
      ];
    case 2:
      return [...commonSizes, '(max-width: 1280px) 238px', '288px'];
    case 3:
      return [...commonSizes, '(max-width: 1280px) 238px', '288px'];

    case 4:
      return [
        ...commonSizes,
        '(max-width: 1280px) 400px',
        '(max-width: 1440px) 475px',
        '500px',
      ];
    case 5:
      return [...commonSizes, '(max-width: 1280px) 325px', '388px'];

    default:
      return '500px';
  }
};

export const Mosaic = ({ items }: MosaicProps) => {
  return (
    <div className="Mosaic w-full mx-auto">
      <div className="flex flex-col gap-24">
        <div className="flex flex-col flex-wrap md:flex-row">
          {items?.map(({ type, ...item }: MosaicItem, i: number) => {
            const style = computeStylesFromIndex(i);
            const sizes = computeSizesFromIndex(i);
            if (type === 'video')
              return (
                <VideoMosaic
                  {...item}
                  image={{ ...item.image, sizes }}
                  className={classNames(style)}
                  key={i}
                  sizes={sizes}
                />
              );
            if (type === 'buttonCard')
              return (
                <ButtonCardMosaic
                  key={i}
                  {...item}
                  image={{ ...item.image, sizes }}
                  className={style}
                  sizes={sizes}
                />
              );
            if (type === 'image')
              return (
                <ImageMozaic
                  key={i}
                  {...item}
                  className={classNames(
                    style,
                    // i !== 1 && 'hidden lg:block',
                    item?.className,
                  )}
                  sizes={sizes}
                />
              );
            return <Fragment key={i} />;
          })}
        </div>
      </div>
    </div>
  );
};
